import {decorate, observable} from 'mobx';
import {faPoll} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class ReportLog extends BaseModel {
  static faIcon = faPoll;

  searchableProperties = [
    'type.type', 'state',
    'workplace.no', 'workplace,name',
  ];

  static prepareApiPayload(model) {
    return {
      id: model.id,
      typeId: model.typeId,
      state: model.state,
      operationId: model.operationId,
      workplaceId: model.workplaceId,
      report: model.report,
    };
  }

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);

    this.type = rootStore.reportTypeStore.getById(this.typeId);
    if (this.operationId) this.operation = rootStore.operationStore.getById(this.operationId);
    if (this.workplaceId) this.workplace = rootStore.workplaceStore.getById(this.workplaceId);
  }
}

decorate(ReportLog, {
  id: observable,
  typeId: observable,
  type: observable,
  state: observable,
  operationId: observable,
  operation: observable,
  workplaceId: observable,
  workplace: observable,
  report: observable,
  ...ReportLog.modelChangeDecorations,
});

/**
 * event context translations:
 * t('reportLog.states.DRAFT')
 * t('reportLog.states.PENDING')
 * t('reportLog.states.SUCCESS')
 * t('reportLog.states.FAILURE')
 * t('reportLog.states.ARCHIVED')
 */
export const ReportStates = Object.freeze({
  Draft: 'DRAFT',
  Pending: 'PENDING',
  Success: 'SUCCESS',
  Failure: 'FAILURE',
  Archived: 'ARCHIVED',
});
